<template>
  <div class="meet-header">
    <div class="meet-header-ul">
      <div class="meet-header-li" v-for="(menu, index) in list" :key="index" @click="openLink(menu)">
        <img
          :src="require(`@/assets/images/icon/${menu.icon}.png`)"
          class="meet-header-menu-icon"
          alt="图标"
        />
        <span class="meet-header-menu-title">{{ menu.title }}</span>
      </div>
    </div>
  </div>
</template>
<style>
</style>
<script>
import MyDialog from '@/components/unit/dialog/index.js'
import MyPopup from '@/components/unit/PagePopup.js'
import login from './login'
export default {
  name: "MeetHeader",
  mixins:[login],
  data: () => {
    return {
      list: [
        {
          icon: "download",
          key: "download",
          title: "下载物料",
          link: "/page/meet/components/material.vue",
        },
        {
          icon: "invite-select",
          key:"invite",
          title: "邀请协作人",
          link: "/page/meet/components/inviteCollaborators.vue",
        },
        {
          icon: "history-select",
          key:"history",
          title: "历史版本查看",
          link:"/unit/historyVersion.vue"
        },
        {
          icon: "submit-select",
          key:"submit",
          title: "提交"
        },
      ],
      loginLink:"/page/user/loginSales.vue"
    };

  },
  methods:{
    async openLink(item){
      try{
        await this.login()
      }catch(err){
        console.log(err)
        return;
      }
      if(!item.link){
        this.doCommit();
        return;
      }
      if(item.key == 'history'){
        this.openHistroy(item)
        return;
      }
      MyDialog({link:item.link,query:this.$route.query}).then(res=>{
        console.log(res)
        this.$emit("updateMeetInfo")
      }).catch(()=>{
        console.log(0)
      })
    },
    openHistroy(item){
      
      MyPopup({content:["请问是否需要保留当前页面内容？"],cancelText:"不保存",comfirmText:"保存"}).then(res=>{
              this.doCommit((status)=>{
                if(!status) return;
                MyDialog({link:item.link,query:this.$route.query}).then(res=>{
                  console.log(res)
                  this.$emit("updateMeetInfo")
                }).catch(()=>{
                  console.log(0)
                })
              })
            }).catch(err=>{
                MyDialog({link:item.link,query:this.$route.query}).then(res=>{
                  console.log(res)
                  this.$emit("updateMeetInfo")
                }).catch(()=>{
                  console.log(0)
                })
            })
    },
    doCommit(callback){
      if(this.loading) return;
      this.loading = true
      let loading = this.$tips.loading({text:"提交中..."})
      let url = this.$tools.getURL(this.$urls.meet.submit,this.$route.query)
      this.$axios.get(url).then(()=>{
        this.$tips.success({text:"提交成功"})
        setTimeout(()=>{
          this.loading = false;
          loading.close()
        callback && callback(true)
        },1000)
      }).catch(err=>{
        setTimeout(()=>{
          this.loading = false;
          loading.close()
          callback && callback(false)
        },1000)

      })

    },
  },
};
</script>
<style lang="scss" scoped>
.meet-header {
  width: 100%;
  height: 54px;
  box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.06);
  background: #fff;
  padding: 8.5px 13px;
}
.meet-header-menu-icon {
  height: 19.5px;
  width: auto;
}
.meet-header-ul {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.meet-header-li {
  flex: 1 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-right: 1px solid #dcdcdc;
  // color: #231815;
  color: var(--el-color-primary);
}
.meet-header-li:last-child {
  border: none;
}
// .meet-header-li:first-child {
//   color: var(--el-color-primary);
// }
.meet-header-menu-title {
  margin-top: 8px;
  font-size: 11px;
}
</style>